import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BrowserRouter as Router, Link } from "react-router-dom";

export default function Logo(props) {
    const name = props.name
    const [hoverColor, setHoverColor] = React.useState('#c49c80');

    function getRandomInt(max) {
        return Math.floor(Math.random() * max);
      }
    
      const hover_colors = ['#c49c80', '#c187e8', '#92e887', '#87b1e8', '#f7941d']
    
      const handleHoverCover = () => {
        var dif_colors = hover_colors.filter(color => color !== hoverColor)
        var rand_int = getRandomInt(dif_colors.length)
        setHoverColor(dif_colors[rand_int])
      }

    return (
        <Box display="flex" alignItems="center">
            <Box
              onMouseEnter={handleHoverCover}
              sx={{
                width: 16,
                height: 16,
                backgroundColor: hoverColor,
                marginRight: '16px',
              }}
            />
            <Link
              to="/home"
              style={{
                textDecoration: "none",
                color: "#ffffff",
                alignItems: "baseline"
              }}
            >
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ color: 'black', mr: 2, display: { xs: 'none', md: 'flex' }, "&:hover": { color: hoverColor } }}
            >
              {name !== undefined ? name : "Good Blocks"}
            </Typography>
            </Link>
        </Box>
    )
}